export default __webpack_public_path__ + "static/media/times-new-roman-italic.2e3b2db1.ttf";